import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'floow-us',
  templateUrl: './floow-us.component.html',
  styleUrls: ['./floow-us.component.css']
})
export class FloowUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/contact-us/floow-us/floow-us.component.ts